// Crew — small feedback primitives (Agent B): spinner, error banner, empty state.
import type { ReactNode } from 'react';

export function Spinner({ label = 'Loading…' }: { label?: string }) {
  return (
    <div className="flex items-center justify-center gap-3 py-10 text-ink-700" role="status">
      <span
        aria-hidden
        className="h-5 w-5 animate-spin rounded-full border-2 border-coral-500 border-t-transparent"
      />
      <span className="text-sm">{label}</span>
    </div>
  );
}

export function ErrorBanner({ message, onRetry }: { message: string; onRetry?: () => void }) {
  return (
    <div
      role="alert"
      className="flex flex-wrap items-center justify-between gap-3 rounded-xl2 bg-coral-400/15 px-4 py-3 text-sm text-coral-600 ring-1 ring-coral-400/40"
    >
      <span>{message}</span>
      {onRetry && (
        <button
          type="button"
          onClick={onRetry}
          className="font-semibold underline underline-offset-2 hover:text-coral-700"
        >
          Retry
        </button>
      )}
    </div>
  );
}

export function EmptyState({ title, children }: { title: string; children?: ReactNode }) {
  return (
    <div className="rounded-xl2 border border-dashed border-sand-300 bg-white/40 px-5 py-8 text-center">
      <p className="font-medium text-ink-800">{title}</p>
      {children && <p className="mt-1 text-sm text-ink-700/70">{children}</p>}
    </div>
  );
}
